import styled from 'styled-components';

export const PreferencesListDefaultStyles = styled.div`
  --preference-item-size: 100px;
  --preferences-list-padding: 8px 24px;
  --preferences-list-gap-x: 20px;
  --preferences-list-gap-y: 20px;
  display: grid;
  align-items: flex-start;
  grid-template-columns: repeat(
    auto-fit,
    minmax(var(--preference-item-size), 1fr)
  );
  column-gap: var(--preferences-list-gap-x);
  row-gap: var(--preferences-list-gap-y);
  padding: var(--preferences-list-padding);
  width: 100%;
  margin: 8px auto 0;

  .list-item {
    display: grid;
    place-items: center;

    input[type='checkbox'] {
      display: none;
    }

    &-img {
      display: block;
      width: var(--preference-item-size);
      height: var(--preference-item-size);
      object-fit: cover;
      object-position: center center;
      background-color: var(--ion-placeholder-background);
      margin-bottom: 4px;

      &.shape-circle {
        border-radius: 100%;
      }

      &.shape-square {
        border-radius: 12px;
      }

      &.checkedImg {
        outline: 8px solid var(--color-primary-main);
        outline-offset: -8px;
      }
    }
  }
`;
